/* ============================================
   SECONDSKIN THEME — TELEVIDEO JAVASCRIPT
   Legge window.SS per le impostazioni dal customizer
   ============================================ */

(function () {
  'use strict';

  var S = window.SS || {};
  var animOn        = S.anim          !== false;
  var loadingOn     = S.loading       !== false;
  var glitchOn      = S.glitch        !== false;
  var scanlinesOn   = S.scanlines     !== false;
  var cardsOn       = S.cards         !== false;
  var countersOn    = S.counters      !== false;
  var typewriterOn  = S.typewriter    !== false;
  var transitionOn  = S.pageTransition !== false;
  var rankingApi    = String(S.rankingApi || '').replace(/\/+$/, '');

  var scanDur   = S.scanlineSpeed === 'slow' ? 12000 : S.scanlineSpeed === 'fast' ? 4000  : 8000;
  var statusMs  = S.statusSpeed   === 'slow' ? 6000  : S.statusSpeed   === 'fast' ? 1500  : 3000;
  var glitchMs  = S.glitchFreq    === 'rare' ? 12000 : S.glitchFreq    === 'often' ? 2000  : 6000;

  /* ══════════════════════════════════════
     1. LIVE CLOCK
  ══════════════════════════════════════ */
  function updateClock() {
    var el = document.getElementById('tv-clock');
    if (!el) return;
    var now = new Date();
    var days   = ['Do','Lu','Ma','Me','Gi','Ve','Sa'];
    var months = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
    var h = String(now.getHours()).padStart(2,'0');
    var m = String(now.getMinutes()).padStart(2,'0');
    var s = String(now.getSeconds()).padStart(2,'0');
    el.textContent = days[now.getDay()] + ' ' + String(now.getDate()).padStart(2,'0') +
      ' ' + months[now.getMonth()] + '  ' + h + ':' + m + ':' + s;
  }
  updateClock();
  setInterval(updateClock, 1000);

  /* GALLERIE PRODOTTO — funzionali anche con animazioni disattivate */
  function initProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
      var counter = gallery.querySelector('[data-gallery-counter]');
      if (!main || !thumbs.length) return;
      var current = 0;

      function show(index) {
        current = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[current];
        main.src = thumb.getAttribute('data-src');
        main.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (item, itemIndex) {
          item.classList.toggle('is-active', itemIndex === current);
        });
        if (counter) counter.textContent = (current + 1) + ' / ' + thumbs.length;
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { show(index); });
      });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
    });
  }

  function initCardGalleries() {
    document.querySelectorAll('[data-card-gallery]').forEach(function (gallery) {
      var images = Array.prototype.slice.call(gallery.querySelectorAll('[data-card-image]'));
      if (images.length < 2) return;
      var current = 0;

      function show(index) {
        current = (index + images.length) % images.length;
        images.forEach(function (image, imageIndex) {
          image.classList.toggle('is-active', imageIndex === current);
        });
      }

      var prev = gallery.querySelector('[data-card-prev]');
      var next = gallery.querySelector('[data-card-next]');
      if (prev) prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(current - 1);
      });
      if (next) next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(current + 1);
      });
    });
  }

  function initProductRecommendations() {
    var container = document.querySelector('.tv-product-recommendations');
    if (!container) return;

    var url = container.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContainer = doc.querySelector('.tv-product-recommendations');
        
        if (newContainer && newContainer.querySelector('.tv-grid')) {
          container.innerHTML = newContainer.innerHTML;
          initCardGalleries();
        }
      })
      .catch(function(e) { console.error('Error loading recommendations', e); });
  }

  function createVisitorId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var value = char === 'x' ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }

  function getVisitorId() {
    var key = 'secondskin_storefront_visitor';
    try {
      var existing = window.localStorage.getItem(key);
      if (existing) return existing;
      var created = createVisitorId();
      window.localStorage.setItem(key, created);
      return created;
    } catch (_error) {
      return createVisitorId();
    }
  }

  function trackProductView() {
    var product = document.querySelector('[data-product-view-id]');
    if (!product || !rankingApi) return;
    var productId = product.getAttribute('data-product-view-id');
    if (!productId) return;
    var body = new URLSearchParams({
      productId: productId,
      visitorId: getVisitorId()
    });
    var url = rankingApi + '/product-views';
    if (navigator.sendBeacon && navigator.sendBeacon(url, body)) return;
    fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body.toString()
    }).catch(function () {});
  }

  function rankNewArrivals() {
    var grid = document.querySelector('[data-new-arrivals-grid]');
    if (!grid || !rankingApi) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-product-card]'));
    if (cards.length < 2) return;
    var displayLimit = parseInt(grid.getAttribute('data-display-limit'), 10) || cards.length;
    var cardsById = {};
    var productIds = cards.map(function (card) {
      var productId = card.getAttribute('data-product-id');
      if (productId) cardsById[productId] = card;
      return productId;
    }).filter(Boolean);
    if (!productIds.length) return;

    fetch(rankingApi + '/product-ranking?productIds=' + encodeURIComponent(productIds.join(',')), {
      mode: 'cors',
      credentials: 'omit'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Ranking non disponibile');
        return response.json();
      })
      .then(function (payload) {
        var rankedIds = payload && Array.isArray(payload.products)
          ? payload.products.map(function (entry) { return String(entry.productId); })
          : [];
        if (!rankedIds.length) return;
        var rankedSet = {};
        var orderedCards = [];
        rankedIds.forEach(function (productId) {
          if (cardsById[productId] && !rankedSet[productId]) {
            rankedSet[productId] = true;
            orderedCards.push(cardsById[productId]);
          }
        });
        cards.forEach(function (card) {
          var productId = card.getAttribute('data-product-id');
          if (!rankedSet[productId]) orderedCards.push(card);
        });
        orderedCards.forEach(function (card, index) {
          card.hidden = index >= displayLimit;
          grid.appendChild(card);
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductGalleries();
      initCardGalleries();
      initProductRecommendations();
      trackProductView();
      rankNewArrivals();
    });
  } else {
    initProductGalleries();
    initCardGalleries();
    initProductRecommendations();
    trackProductView();
    rankNewArrivals();
  }

  if (!animOn) return; /* ── se animazioni disabilitate, stop qui ── */

  /* ══════════════════════════════════════
     2. PAGE NUMBER FLICKER
  ══════════════════════════════════════ */
  function initPageFlicker() {
    var el = document.getElementById('tv-page-num');
    if (!el) return;
    setInterval(function () {
      el.style.visibility = 'hidden';
      setTimeout(function () { el.style.visibility = 'visible'; }, 80);
      setTimeout(function () { el.style.visibility = 'hidden'; }, 140);
      setTimeout(function () { el.style.visibility = 'visible'; }, 220);
    }, 4000 + Math.random() * 3000);
  }
  initPageFlicker();

  /* ══════════════════════════════════════
     3. LOADING OVERLAY
  ══════════════════════════════════════ */
  if (loadingOn) {
    function initLoadEffect() {
      var overlay = document.createElement('div');
      overlay.style.cssText = [
        'position:fixed','top:0','left:0','width:100%','height:100%',
        'background:#0a0a1a','z-index:9999','pointer-events:none',
        'display:flex','align-items:center','justify-content:center',
        'font-family:\'VT323\',monospace','font-size:clamp(20px,3vw,28px)',
        'letter-spacing:0.1em','transition:opacity 0.4s ease'
      ].join(';');

      var msgs = ['INIZIALIZZAZIONE...','CARICAMENTO ARCHIVIO...','CONNESSIONE RAI...','SECONDSKIN ONLINE'];
      var inner = document.createElement('div');
      inner.style.cssText = 'text-align:center;';
      var line1 = document.createElement('div');
      line1.style.color = '#FFFF00';
      line1.textContent = '█ SECONDSKIN ARCHIVIO █';
      var line2 = document.createElement('div');
      line2.style.cssText = 'color:#00FF00;margin-top:16px;min-height:1.4em;';
      line2.textContent = msgs[0];
      var line3 = document.createElement('div');
      line3.style.cssText = 'color:#555;margin-top:8px;font-size:0.7em;';
      line3.textContent = 'P.100 RAI TELEVIDEO';

      inner.appendChild(line1); inner.appendChild(line2); inner.appendChild(line3);
      overlay.appendChild(inner);
      document.body.appendChild(overlay);

      var idx = 0;
      var interval = setInterval(function () {
        idx++;
        if (idx < msgs.length) {
          line2.textContent = msgs[idx];
          line2.style.color = idx % 2 === 0 ? '#00FF00' : '#00FFFF';
        } else {
          clearInterval(interval);
          overlay.style.opacity = '0';
          setTimeout(function () { overlay.remove(); }, 500);
        }
      }, 320);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLoadEffect);
    } else {
      initLoadEffect();
    }
  }

  /* ══════════════════════════════════════
     4. STATUS BAR CYCLING
  ══════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('tv-status');
    if (!el) return;
    var messages = [
      { text: '● ONLINE',          color: '#00FF00' },
      { text: '▶ AGGIORNATO OGGI', color: '#00FFFF' },
      { text: '■ SPEDIZIONE GRATIS',color: '#FFFF00' },
      { text: '● ROMA, ITALIA',     color: '#00FF00' },
      { text: '▶ SOLO PEZZI UNICI', color: '#FF0000' },
      { text: '■ 100% VINTAGE',     color: '#00FFFF' },
    ];
    var idx = 0;
    el.style.transition = 'opacity 0.3s';
    setInterval(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % messages.length;
        el.textContent = messages[idx].text;
        el.style.color  = messages[idx].color;
        el.style.opacity = '1';
      }, 300);
    }, statusMs);
  });

  /* ══════════════════════════════════════
     5. TYPEWRITER — usa la classe .tv-typewriter
  ══════════════════════════════════════ */
  if (typewriterOn) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.tv-typewriter').forEach(function (el) {
        var full = el.textContent;
        el.textContent = '';
        el.style.borderRight = '2px solid currentColor';
        var i = 0;
        var t = setInterval(function () {
          if (i < full.length) { el.textContent += full[i]; i++; }
          else { clearInterval(t); setTimeout(function () { el.style.borderRight = 'none'; }, 600); }
        }, 55);
      });
    });
  }

  /* ══════════════════════════════════════
     6. CARD REVEAL on scroll
  ══════════════════════════════════════ */
  if (cardsOn) {
    document.addEventListener('DOMContentLoaded', function () {
      var cards = document.querySelectorAll('.tv-card');
      if (!cards.length) return;
      var style = document.createElement('style');
      style.textContent = '.tv-card-hidden{opacity:0;transform:translateY(12px);} .tv-card-visible{transition:opacity 0.4s ease,transform 0.4s ease;opacity:1;transform:translateY(0);}';
      document.head.appendChild(style);
      cards.forEach(function (c) { c.classList.add('tv-card-hidden'); });
      if ('IntersectionObserver' in window) {
        var delay = 0;
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var card = entry.target;
              setTimeout(function () { card.classList.remove('tv-card-hidden'); card.classList.add('tv-card-visible'); }, delay);
              delay = Math.min(delay + 80, 600);
              obs.unobserve(card);
            }
          });
        }, { threshold: 0.1 });
        cards.forEach(function (c) { obs.observe(c); });
      } else {
        cards.forEach(function (c) { c.classList.remove('tv-card-hidden'); c.classList.add('tv-card-visible'); });
      }
    });
  }

  /* ══════════════════════════════════════
     7. COUNTER ANIMATION
  ══════════════════════════════════════ */
  if (countersOn) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.tv-stat-val[data-count]').forEach(function (el) {
        var target = parseInt(el.getAttribute('data-count'), 10);
        if (isNaN(target)) return;
        var start = 0;
        var step = Math.ceil(target / (1200 / 16));
        var t = setInterval(function () {
          start = Math.min(start + step, target);
          el.textContent = start;
          if (start >= target) clearInterval(t);
        }, 16);
      });
    });
  }

  /* ══════════════════════════════════════
     8. SCANLINE PULSE on images + hover glow
        Velocita scanline: scanDur da settings
  ══════════════════════════════════════ */
  if (scanlinesOn) {
    var style = document.createElement('style');
    style.textContent = [
      '.tv-card-img-wrap{position:relative;overflow:hidden;}',
      '.tv-card-img-wrap::after{',
        'content:"";display:block;',
        'position:absolute;top:-100%;left:0;width:100%;height:300%;',
        'background:repeating-linear-gradient(to bottom,transparent 0px,transparent 3px,rgba(0,0,0,0.08) 3px,rgba(0,0,0,0.08) 4px);',
        'pointer-events:none;',
        'animation:scanScroll ' + (scanDur/1000) + 's linear infinite;',
      '}',
      '.tv-card:hover .tv-card-img-wrap::after{',
        'background:repeating-linear-gradient(to bottom,transparent 0px,transparent 2px,rgba(0,255,255,0.04) 2px,rgba(0,255,255,0.04) 3px);',
        'animation-duration:' + (scanDur/2000) + 's;',
      '}',
      '@keyframes scanScroll{from{transform:translateY(0);}to{transform:translateY(33.33%);}}',
      '.tv-card:hover{box-shadow:0 0 0 2px #FFFF00,0 0 20px rgba(255,255,0,0.15);transition:box-shadow 0.2s;}'
    ].join('');
    document.head.appendChild(style);
  }

  /* ══════════════════════════════════════
     9. GLITCH on page number
        Frequenza: glitchMs da settings
  ══════════════════════════════════════ */
  if (glitchOn) {
    document.addEventListener('DOMContentLoaded', function () {
      var el = document.getElementById('tv-page-num');
      if (!el) return;
      function glitch() {
        el.style.textShadow = '2px 0 #FF0000, -2px 0 #00FFFF';
        setTimeout(function () { el.style.textShadow = ''; }, 100);
        setTimeout(function () {
          el.style.textShadow = '-1px 0 #00FF00';
          setTimeout(function () { el.style.textShadow = ''; }, 80);
        }, 180);
        setTimeout(glitch, glitchMs + Math.random() * glitchMs * 0.5);
      }
      setTimeout(glitch, 3000);
    });
  }

  /* ══════════════════════════════════════
     10. CART COUNT BADGE
  ══════════════════════════════════════ */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.tv-cart-count').forEach(function (b) {
          b.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
        });
      }).catch(function () {});
  }
  updateCartCount();

  /* ══════════════════════════════════════
     11. ADD TO CART (AJAX)
  ══════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (body) { throw new Error(body.description || 'Aggiunta al carrello non riuscita'); });
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓ OK';
        btn.style.color = '#00FF00';
        updateCartCount();
        setTimeout(function () { btn.textContent = '+CARR.'; btn.style.color = ''; btn.disabled = false; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'ERRORE';
        btn.style.color = '#FF3333';
        setTimeout(function () { btn.textContent = '+CARR.'; btn.style.color = ''; btn.disabled = false; }, 2200);
      });
  });

  document.addEventListener('click', function (e) {
    var thumbnail = e.target.closest('[data-product-image]');
    if (!thumbnail) return;
    var mainImage = document.getElementById('tv-product-main-image');
    if (!mainImage) return;
    mainImage.src = thumbnail.getAttribute('data-product-image');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var thumbnail = e.target.closest('[data-product-image]');
    if (!thumbnail) return;
    e.preventDefault();
    thumbnail.click();
  });

  /* ══════════════════════════════════════
     12. CART QUANTITY BUTTONS
  ══════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var key   = btn.getAttribute('data-line-key');
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var qtyEl = btn.closest('.tv-cart-qty') && btn.closest('.tv-cart-qty').querySelector('[data-qty-display]');
    var current = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
    var newQty  = Math.max(0, current + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(function () { window.location.reload(); }).catch(function () {});
  });

  /* ══════════════════════════════════════
     13. COLLECTION FILTERS
  ══════════════════════════════════════ */
  var filterBtns   = document.querySelectorAll('.tv-filter-btn');
  var productCards = document.querySelectorAll('[data-product-card]');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.getAttribute('data-filter-group');
      document.querySelectorAll('.tv-filter-btn[data-filter-group="' + group + '"]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      filterProducts();
    });
  });

  function filterProducts() {
    var activeCond = document.querySelector('.tv-filter-btn[data-filter-group="condition"].active');
    var activeEra  = document.querySelector('.tv-filter-btn[data-filter-group="era"].active');
    var condVal = activeCond ? activeCond.getAttribute('data-filter-value') : 'all';
    var eraVal  = activeEra  ? activeEra.getAttribute('data-filter-value')  : 'all';
    productCards.forEach(function (card) {
      var condMatch = condVal === 'all' || (card.getAttribute('data-condition')||'').toLowerCase() === condVal.toLowerCase();
      var eraMatch  = eraVal  === 'all' || (card.getAttribute('data-era')||'') === eraVal;
      card.style.display = (condMatch && eraMatch) ? '' : 'none';
    });
  }

  /* ══════════════════════════════════════
     14. SEARCH FILTER
  ══════════════════════════════════════ */
  var searchInput = document.getElementById('tv-search');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.toLowerCase();
      productCards.forEach(function (card) {
        card.style.display = (card.getAttribute('data-name')||'').toLowerCase().includes(q) ? '' : 'none';
      });
    });
  }

  /* ══════════════════════════════════════
     15. PAGE TRANSITION FLASH
  ══════════════════════════════════════ */
  if (transitionOn) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') || link.target === '_blank' || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      var flash = document.createElement('div');
      flash.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:#FFFF00;z-index:9998;opacity:0;pointer-events:none;transition:opacity 0.08s;';
      document.body.appendChild(flash);
      requestAnimationFrame(function () {
        flash.style.opacity = '0.06';
        setTimeout(function () {
          flash.style.opacity = '0';
          setTimeout(function () { window.location.href = href; }, 100);
        }, 80);
      });
    });
  }

})();
